import { NotificationSeverity } from '@/components/notifications/Notification';
import { INTEGRATION_REQUESTS_PATH, apiErrorMessage } from './config';
import { LoaderBackdrop, NavigateLinks } from '@/components';
import { useNavigate, useParams } from 'react-router-dom';
import { useIntegrationRequestBreadcrumbs } from './hooks';
import { useNotification } from '@/hooks';
import {
  EDITABLE_INTEGRATION_REQUEST_STATUSES,
  type IntegrationRequestPayload,
} from '../../models/IntegrationRequest';
import {
  useGetIntegrationRequestByIdQuery,
  useUpdateIntegrationRequestMutation,
} from '../../services';
import { IntegrationRequestForm } from './components';

const EditIntegrationRequestPage = () => {
  const navigate = useNavigate();
  const { requestId = '' } = useParams<{ requestId: string }>();
  const { showNotification } = useNotification();
  const { data: request, isLoading } = useGetIntegrationRequestByIdQuery(
    requestId,
    { skip: !requestId }
  );
  const [updateRequest, { isLoading: isSaving }] = useUpdateIntegrationRequestMutation();

  const detailPath = `${INTEGRATION_REQUESTS_PATH}/${requestId}`;
  const breadcrumbs = useIntegrationRequestBreadcrumbs();

  const handleSubmit = async (payload: IntegrationRequestPayload) => {
    try {
      await updateRequest({ requestId, payload }).unwrap();
      showNotification('Solicitud actualizada y reenviada a TI', NotificationSeverity.success);
      navigate(detailPath);
    } catch (error) {
      showNotification(
        apiErrorMessage(error, 'No se pudo actualizar la solicitud'),
        NotificationSeverity.error
      );
    }
  };

  if (isLoading) return <LoaderBackdrop />;

  return (
    <section className='flex flex-col gap-6 w-full h-full'>
      <NavigateLinks actualPage='Editar solicitud de integración' breadcrumbs={breadcrumbs} />

      {!request ? (
        <p className='text-sm text-red-600'>No se encontró la solicitud.</p>
      ) : !EDITABLE_INTEGRATION_REQUEST_STATUSES.includes(request.status) ? (
        <p className='text-sm text-gray-600'>
          Esta solicitud ya no se puede editar: TI la está procesando o ya terminó.
        </p>
      ) : (
        <>
          {request.observation && (
            <div className='rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800'>
              <strong>Observación de TI:</strong> {request.observation}
            </div>
          )}
          <IntegrationRequestForm
            commerceId={request.commerceId}
            initialRequest={request}
            isSaving={isSaving}
            submitLabel='Guardar y reenviar'
            onSubmit={handleSubmit}
            onCancel={() => navigate(detailPath)}
          />
        </>
      )}
    </section>
  );
};

export default EditIntegrationRequestPage;
